import React from 'react';
import { CulinaryGrid } from '../components/CulinaryGrid';
export function Menu() {
  return <main className="pt-24 min-h-screen" data-id="element-351">
      <CulinaryGrid data-id="element-352" />
    </main>;
}